import React from 'react';
import PropTypes from 'prop-types';
import './InviteFriendModal.scss';

import Spinner from '../../../../components/Spinner';
import Segment from '../../../../components/Segment';
import Form from '../../../../components/Form/Form';

import { validateEmail } from 'components/Utils';

import CancelImage from './images/cancel.png';

// eslint-disable-next-line
const EmailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

const analytics = new Segment();

class InviteFriendModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      submittingInviteForm: false,
      inviteForm: {
        send_to: null,
        email: null,
        name: null
      },
      inviteFormErrors: {
        send_to: null,
        email: null,
        name: null
      }
    };

    this.handleInviteForm = this.handleInviteForm.bind(this);
    this.sendEmailShare = this.sendEmailShare.bind(this);
  }

  handleInviteForm (event) {
    this.setState({
      inviteForm: event.target.value,
    });
  }

  extractValidEmails (emails) {
    if (!emails) {
      return false;
    }

    const Recipients = emails.split(',') || [];

    if (Recipients.length === 0) {
      return false;
    }

    const Emails = Recipients.reduce((sum, val) => {
      if (EmailRegex.test(val.replace(/\s+/g, ''))) {
        return [
          ...sum,
          val.replace(/\s+/g, '')
        ];
      }
      return sum;
    }, []);

    return Emails;
  }

  sendEmailShare () {
    console.log(this.state.inviteForm);
    if (!this.state.inviteForm) {
      return false;
    }

    let hasErrors = false;
    let validationErrors = {
      send_to: null,
      email: null,
      name: null
    };

    let Emails = this.extractValidEmails(this.state.inviteForm.send_to);

    if (!this.state.inviteForm.send_to || Emails.length === 0) {
      validationErrors.send_to = 'Please enter a valid email';
      hasErrors = true;
    }

    if (!this.state.inviteForm.email || !validateEmail(this.state.inviteForm.email)) {
      validationErrors.email = 'Please enter a valid email';
      hasErrors = true;
    }

    if (!this.state.inviteForm.name) {
      validationErrors.name = 'Please enter your name';
      hasErrors = true;
    }

    this.setState({
      inviteFormErrors: validationErrors,
    });

    if (hasErrors) return false;

    if (Object.prototype.hasOwnProperty.call(this.state.inviteForm, 'send_to') &&
     Object.prototype.hasOwnProperty.call(this.state.inviteForm, 'name')) {
      this.setState({
        submittingInviteForm: true,
      });

      analytics.track('Shared Office Hours by email', {
        recipient_emails: Emails,
        sender_email: this.state.inviteForm.email || '',
        name: this.state.inviteForm.name,
        message: this.state.inviteForm.optional_message
      });

      this.props.sendEmailInvite({
        variables: {
          SendArray: Emails,
          Email: this.state.inviteForm.email || '',
          Name: this.state.inviteForm.name,
          Message: this.state.inviteForm.optional_message
        }
      }).then(() => {
        this.setState({
          submittingInviteForm: false,
          inviteForm: {
            send_to: null,
            email: null,
            name: null
          },
          inviteFormErrors: {
            send_to: null,
            email: null,
            name: null
          }
        });

        this.props.onDismiss();
      }).catch(err => {
        console.log(err);
        this.setState({
          submittingInviteForm: false,
        });
      });
    }
  }

  render () {
    // return (
    //   <Modal isOpen={this.props.isOpen}>
    //     <ModalHeader>{this.props.title}</ModalHeader>
    //     <ModalBody>
    //       {this.props.message}
    //     </ModalBody>
    //     <ModalFooter>
    //       <Button color='primary' onClick={this.props.onDismiss}>OK</Button>
    //     </ModalFooter>
    //   </Modal>
    // );

    if (this.props.isOpen !== false) {
      return (
        <div className='OfficeHoursModal'>
          <div className='OfficeHoursModal__Background' onClick={this.props.onDismiss} />
          <div className='OfficeHoursModal__Content'>
            <div className='OfficeHoursModal__InternalWrap'>
              <a className='OfficeHoursModal__Cancel' onClick={this.props.onDismiss}>
                <img src={CancelImage} />
              </a>
              <div className='SendToFriend__ModalWrap'>
                <h5>
                  Share Tea Time with a Friend
                </h5>
                <Form onChange={this.handleInviteForm}>
                  <p className='FormLabel'>Send to</p>
                  <input type='text' name='send_to' placeholder='Up to 10 emails, seperated by commas' />
                  <p className='text-danger'>{this.state.inviteFormErrors.send_to}</p>
                  <p className='FormLabel'>Your Email Address</p>
                  <input type='text' name='email' placeholder='Enter your email' />
                  <p className='text-danger'>{this.state.inviteFormErrors.email}</p>
                  <p className='FormLabel'>Your Name</p>
                  <input type='text' name='name' placeholder='Enter your name' />
                  <p className='text-danger'>{this.state.inviteFormErrors.name}</p>
                  <p className='FormLabel'>Optional message</p>
                  <textarea name='optional_message' rows={2} />
                </Form>
                <a className='button' onClick={this.sendEmailShare}>
                  {(this.state.submittingInviteForm) ? <Spinner className='spinner--white' /> : 'Send this page'}
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

InviteFriendModal.propTypes = {
  isOpen: PropTypes.bool,    // Should the modal be open?
  onDismiss: PropTypes.func,  // When modal needs to be closed
  sendEmailInvite: PropTypes.func // Sending the email
};

export default InviteFriendModal;



// WEBPACK FOOTER //
// ./src/routes/officehours/components/InviteFriendModal/index.js